<template>
	<a class="to-top" @click="scrollToTop()" />
</template>

<script setup>
const handleScroll = () => {
	const fixedElements = document.querySelectorAll('.to-top');
	if (window.pageYOffset >= 350) {
		fixedElements.forEach((el) => el.classList.add('show'));
	} else {
		fixedElements.forEach((el) => el.classList.remove('show'));
	}
};

const scrollToTop = () => {
	window.scroll({
		top: 0,
		left: 0,
		behavior: 'smooth',
	});
};

onBeforeMount(() => {
	window.addEventListener('scroll', handleScroll);
});

onBeforeUnmount(() => {
	window.removeEventListener('scroll', handleScroll);
});
</script>

<style lang="scss" scoped>
.to-top {
	position: fixed;
	bottom: 20px;
	left: 20px;
	opacity: 0;
	text-align: center;
	cursor: pointer;
	z-index: 99;
	background: url('~/assets/images/icon-scroll-up.png') no-repeat center center;
	width: 50px;
	height: 50px;
	background-size: 50px;
	border-radius: 50%;

	&:hover {
		color: var(--cta-color);
	}

	&.show {
		opacity: 1;
	}

	span {
		border-top: 1px solid #333;
		border-right: 1px solid #333;
		width: 10px;
		height: 10px;
		transform: rotate(-45deg);
		display: block;
	}
}

@media (max-width: 600px) {
	.to-top {
		bottom: 70px;
	}
}
</style>
